import React from 'react';
import './userData.css';
import { useSelector } from "react-redux";
import Subscription from "../Subscription/Subscription";

const UserData = () => {
    const subscriptions = useSelector(state => state.subscriptions);

    return (
        <div className="udata">
            {
                subscriptions.length > 0
                ?
                    <div className="udata__subscriptions">
                        {
                            subscriptions.map(elem => {
                                return (
                                    <Subscription data={ elem } key={ elem.id }/>
                                );
                            })
                        }
                    </div>
                :
                    <div className="udata__no-subscriptions">Нет доступных абонементов</div>
            }
        </div>
    );
};

export default UserData;